var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInfosBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55739 11.0722C4.74644 10.5974 5.2067 10.2857 5.71877 10.2857H23.7491C24.6319 10.2857 25.2364 11.1742 24.9105 11.9928L20.4426 23.2135C20.2536 23.6883 19.7933 24 19.2812 24H1.25088C0.368056 24 -0.236425 23.1115 0.0895045 22.293L4.55739 11.0722Z",
    fill: "#2D4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53422 6.98182C0.844051 6.98182 0.284558 7.54001 0.284558 8.22857V19.5308C0.284558 19.5452 0.284802 19.5595 0.285285 19.5738L3.93841 10.4387C4.12792 9.96484 4.58771 9.65397 5.0991 9.65397H20.2791V8.22857C20.2791 7.54001 19.7196 6.98182 19.0295 6.98182H1.53422Z",
    fill: "#2D4040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3446 0.623377C9.3446 0.279095 9.62435 0 9.96944 0C10.3145 0 10.5943 0.279095 10.5943 0.623377V3.11688C10.5943 3.46116 10.3145 3.74026 9.96944 3.74026C9.62435 3.74026 9.3446 3.46116 9.3446 3.11688V0.623377Z",
    fill: "#2D4040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3745 1.27047C14.547 0.972314 14.9292 0.870158 15.228 1.0423C15.5269 1.21444 15.6293 1.59569 15.4567 1.89385L14.2071 4.05329C14.0345 4.35144 13.6524 4.4536 13.3535 4.28146C13.0547 4.10932 12.9523 3.72807 13.1248 3.42991L14.3745 1.27047Z",
    fill: "#2D4040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40844 1.58216C4.2359 1.284 4.33829 0.902751 4.63715 0.730611C4.936 0.55847 5.31814 0.660626 5.49068 0.958783L6.74034 3.11822C6.91288 3.41638 6.81049 3.79763 6.51164 3.96977C6.21279 4.14191 5.83065 4.03976 5.6581 3.7416L4.40844 1.58216Z",
    fill: "#2D4040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInfosBase);
export default __webpack_public_path__ + "static/media/noInfosBase.0de13263bbe919435b5bd3d097e3706d.svg";
export { ForwardRef as ReactComponent };